var FoundationModal = {
	Init: function () {

	}

};